import { navigate } from 'gatsby';
import React, { FC } from 'react';

import Button, { IButtonProps } from '@ui/atoms/Button';
import NavigationSection from '@ui/atoms/NavigationSection';

import SubmitButton, { ISubmitButtonProps } from '@ui/molecules/SubmitButton';

import fullWidth from '@ui/styled/FullWidth';

const FullWidthButton = fullWidth<IButtonProps>(Button);
const FullWidthSubmitButton = fullWidth<ISubmitButtonProps>(SubmitButton);

interface ISignInNavigationProps {
	previousPage?: string;
	submitting: boolean;
}

const SignInNavigation: FC<ISignInNavigationProps> = ({ previousPage, submitting }) => (
	<NavigationSection>
		{previousPage ? (
			<FullWidthButton label="Back" onClick={() => navigate(previousPage)} />
		) : (
			<FullWidthButton
				label="Sign up"
				onClick={() => navigate(`/app/flows/membership${location.search}`)}
			/>
		)}
		<FullWidthSubmitButton variant="secondary" label="Sign in" submitting={submitting} />
	</NavigationSection>
);

export default SignInNavigation;
